import type { SVGProps } from "react";

export function DndIcon({
  size = 24,
  strokeWidth = 1.5,
  ...rest
}: { size?: number; strokeWidth?: number } & Omit<SVGProps<SVGSVGElement>, "fill">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M3 11h7l-7 9h7" />
      <path d="M13 6h5l-5 6h5" />
      <path d="M19 2h3l-3 4h3" />
    </svg>
  );
}
